<template>
  <footer class="footer">
    <!-- <div class="newsletter-container py-5 page-container">
      <newsletter />
    </div> -->
    <div class="bg-gray py-5 page-container">
      <partners></partners>
    </div>
    <div class="bg-footerblack pt-5" style="background-image: url(/static/img/home/footer-optimized.png)">
      <div class="page-container">
        <div class="row">
          <div class="col-12 col-md-7">
            <div class="row">
              <div class="col-sm-5 text-center logo-area">
                <b-img :src="isRTL ? '/static/hadaf-logo.svg' : '/static/logo.png'" alt="Shas Illuminated" fluid />

                <div class="d-flex flex-column my-4">
                  <div class="text-uppercase">{{ $_t('pages:contact.hotlineHeading') }}</div>
                  <a class="pb-2" :href="'tel:' + $_t('pages:contact.hotline')">
                    <div>{{ $_t('pages:contact.hotline') }}</div>
                  </a>
                  <a class="pb-2" href="https://play.google.com/store/apps/details?id=com.app.shasilluminated&hl=en&gl=US">
                    <img style="width: 150px" src="/static/img/play-store.png" alt="Play Store" />
                  </a>
                  <a href="https://apps.apple.com/us/app/shas-illuminated/id1491244203">
                    <img style="width: 150px" src="/static/img/app-store.png" alt="App Store" />
                  </a>
                </div>

                <b-button variant="outline-secondary" class="px-4" pill>
                  <i class="fa fa-plus"></i>
                  <span class="ml-2">{{ $_t('KW:donate') }}</span>
                </b-button>
              </div>
              <div class="col-sm-5 offset-sm-1 contact-area text-center text-sm-left mt-5 mt-sm-0">
                <h5 class="text-uppercase mb-sm-3">{{ $_t('KW:contact') }}</h5>
                <ul class="list-unstyled">
                  <li class="text-white mb-4">
                    <div class="d-inline-block align-top">
                      <span>
                        <i class="fa fa-map-marker text-secondary mr-2"></i>
                      </span>
                    </div>
                    <br class="d-sm-none" />
                    <div class="d-inline-block">
                      <span>{{ $_t('pages:contact.address1') }}</span>
                      <br />
                      <span class>{{ $_t('pages:contact.state') }}</span>
                    </div>
                  </li>
                  <li class="mb-4">
                    <a :href="'tel:' + $_t('pages:contact.phoneLink')">
                      <i class="fa fa-phone mr-2 text-secondary"></i>
                      {{ $_t('pages:contact.phone') }}
                    </a>
                  </li>
                  <li>
                    <a :href="'tel:' + $_t('pages:contact.email')">
                      <i class="fa fa-envelope mr-2 text-secondary"></i>
                      {{ $_t('pages:contact.email') }}
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="col-12 text-center text-md-left md-md-0 col-md-5">
            <contact-form :heading="$_t('components:contactForm.heading')"></contact-form>
          </div>
        </div>
      </div>
      <div class="text-white colophon mt-3 py-3">
        <div class="row px-4 mx-auto py-2 align-items-center">
          <div class="col-lg-5 col-md-4 text-center text-md-left">
            <div>
              <span>&copy; {{ $t('copy', { year: new Date().getFullYear() }) }}</span>
            </div>
          </div>
          <div class="col footer-nav float-right d-flex justify-content-center d-md-block">
            <div>
              <b-nav class="float-right text-small">
                <b-nav-item to="/topics">{{ $_t('KW:topics') }}</b-nav-item>
                <b-nav-item to="/magidei-shiur">{{ $_t('KW:speakers') }}</b-nav-item>
                <b-nav-item to="/masechtos">{{ $_t('KW:site.title') }}</b-nav-item>
                <b-nav-item to="/podcasts">{{ $_t('KW:podcasts') }}</b-nav-item>
                <b-nav-item to="/haskamos">{{ $_t('KW:haskamos') }}</b-nav-item>
                <b-nav-item to="/privacy-policy">{{ $_t('KW:privacy_policy') }}</b-nav-item>
                <b-nav-item to="/terms-and-conditions">{{ $_t('KW:terms_and_conditions') }}</b-nav-item>
              </b-nav>
            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>
<script>
import ContactFormComponent from './ContactForm.vue';
import Partners from './Partners.vue';
import NewsletterComponent from './Newsletter.vue';

export default {
  components: {
    ContactForm: ContactFormComponent,
    Partners: Partners,
    // Newsletter: NewsletterComponent,
  },
  i18nOptions: {
    namespaces: 'components',
    keyPrefix: 'footer',
  },
};
</script>
<style lang="scss" scoped>
footer {
  .newsletter-container {
    background: $light-blue;
  }
  .bg-footerblack {
    background-repeat: no-repeat;
    background-size: cover;
    background-position: 0% 8%;
    filter: blur(2);
    span,
    a {
      color: $light-gray;
    }
    .logo-area {
      h4 {
        color: $white;
        font-weight: bold;
      }
      img {
        width: 100px;
      }
      .btn {
        span {
          color: white;
        }
        .fa {
          color: $secondary;
        }
      }
    }

    .contact-area {
      h5 {
        color: $white;
        font-weight: 900;
      }
      .fa {
        font-size: 1.2rem;
        vertical-align: middle;
      }
      li {
        font-size: 1rem;
      }
    }
  }
}
.footer-nav ul.nav {
  @media (max-width: 768px) {
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
